import React, { useState, useEffect, useCallback } from 'react';

/* Единое окно подтверждения в дизайне платформы.
   Использование:  if (await confirmDialog({ title, message, confirmText })) { ... }
   <ConfirmHost/> монтируется один раз в App. */

let _show = null;

export function confirmDialog(opts = {}) {
  return new Promise((resolve) => {
    if (_show) _show(opts, resolve);
    else resolve(window.confirm(opts.message || 'Вы уверены?'));
  });
}

export function ConfirmHost() {
  const [state, setState] = useState(null);

  useEffect(() => {
    _show = (opts, resolve) => setState({ opts, resolve });
    return () => { _show = null; };
  }, []);

  const close = useCallback((val) => {
    setState((s) => { s && s.resolve(val); return null; });
  }, []);

  useEffect(() => {
    if (!state) return;
    const onKey = (e) => {
      if (e.key === 'Escape') close(false);
      if (e.key === 'Enter') close(true);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [state, close]);

  if (!state) return null;
  const { opts } = state;
  const danger = opts.danger !== false; // по умолчанию — опасное действие (удаление)
  const accent = danger ? '#e5484d' : 'var(--primary)';

  return (
    <div onClick={() => close(false)}
      style={{ position: 'fixed', inset: 0, zIndex: 4000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
        background: 'rgba(10,6,18,0.55)', backdropFilter: 'blur(3px)', WebkitBackdropFilter: 'blur(3px)', animation: 'cf-fade .15s ease' }}>
      <style>{`@keyframes cf-fade{from{opacity:0}to{opacity:1}}@keyframes cf-pop{from{opacity:0;transform:translateY(10px) scale(.97)}to{opacity:1;transform:none}}`}</style>
      <div onClick={(e) => e.stopPropagation()}
        style={{ width: '100%', maxWidth: 410, background: 'var(--lg-modal, #fff)', border: '1px solid var(--border)', borderRadius: 20,
          padding: '26px 26px 22px', boxShadow: '0 30px 70px -25px rgba(20,8,50,0.6)', animation: 'cf-pop .2s cubic-bezier(.22,1,.36,1)' }}>
        <div style={{ width: 50, height: 50, borderRadius: 15, display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: danger ? 'rgba(229,72,77,0.13)' : 'var(--primary-light)', color: accent, marginBottom: 16 }}>
          {danger ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          ) : (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          )}
        </div>
        <div style={{ fontSize: 18, fontWeight: 800, color: 'var(--text-1)', letterSpacing: '-0.3px', marginBottom: 7 }}>{opts.title || 'Подтвердите действие'}</div>
        {opts.message && <div style={{ fontSize: 14, lineHeight: 1.55, color: 'var(--text-2)' }}>{opts.message}</div>}
        <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
          <button onClick={() => close(false)}
            style={{ flex: 1, padding: '12px 16px', borderRadius: 12, border: '1px solid var(--border)', background: 'var(--card)', color: 'var(--text-2)', fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
            {opts.cancelText || 'Отмена'}
          </button>
          <button onClick={() => close(true)} autoFocus
            style={{ flex: 1, padding: '12px 16px', borderRadius: 12, border: 'none', background: danger ? '#e5484d' : 'var(--grad-primary)', color: '#fff', fontFamily: 'inherit', fontSize: 14, fontWeight: 700, cursor: 'pointer', boxShadow: danger ? '0 10px 24px -10px rgba(229,72,77,0.6)' : '0 10px 24px -10px rgba(124,77,255,0.7)' }}>
            {opts.confirmText || 'Подтвердить'}
          </button>
        </div>
      </div>
    </div>
  );
}
